
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.15 26.825c1.5 0 2.4 1.3 2.6 2.7.1.1.1.2.1.4.07.14.042.23.02.306-.01.034-.02.064-.02.094-.2 1.5-1.2 2.8-2.8 2.7-1.6-.1-2.6-1.6-2.6-3.1 0-1.6 1-3.1 2.7-3.1z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M49.25 28.325h3.3c1 0 1 3.1.1 3.1h-3.3c-1.1 9.9-8.2 18.2-18.5 18.6v2.3c0 1.9-1.4 1.9-1.4 0v-2.3c-10.1-.4-17.7-8.8-18.5-18.6h-3.2c-1 0-1-3.1 0-3.1h3.2c.7-9.8 8.4-18.2 18.4-18.6v-2.3c0-1.9 1.4-1.9 1.4 0v2.3c10.4.4 17.5 8.8 18.5 18.6zm-18.4 10.1v8.4c8.6-.3 15.9-6.8 17.1-15.4h-9.2c-1 0-1-3.1 0-3.1h9.2c-1.1-8.6-8.4-15.1-17.1-15.4v8.4c0 1.9-1.4 1.9-1.4 0v-8.4c-8.5.3-16.3 6.8-17.1 15.4h9.2c1 0 1 3.1 0 3.1h-9.2c.8 8.6 8.6 15.1 17.1 15.4v-8.4c0-1.9 1.4-1.9 1.4 0z"}})])
          )
        }
      }
    